import React, { useState } from 'react';
import {
  SiAmazonaws,
  SiAwslambda,
  SiAmazonapigateway,
  SiAmazondynamodb,
  SiTerraform,
  SiDocker,
  SiGithubactions,
  SiLinux,
  SiGrafana,
  SiPrometheus,
  SiPython,
  SiPowershell,
  SiPostgresql,
  SiMysql,
  SiKubernetes,
  SiGnubash
} from 'react-icons/si';
import { motion, AnimatePresence } from 'framer-motion';

const skillTabs = {
  Cloud: [
    { name: 'AWS', icon: <SiAmazonaws />, level: 'Advanced', tooltip: 'Amazon Web Services' },
    { name: 'Lambda', icon: <SiAwslambda />, level: 'Core', tooltip: 'Serverless compute' },
    { name: 'API Gateway', icon: <SiAmazonapigateway />, level: 'Core', tooltip: 'API management' },
    { name: 'DynamoDB', icon: <SiAmazondynamodb />, level: 'Core', tooltip: 'NoSQL DB' },
    { name: 'Terraform', icon: <SiTerraform />, level: 'Advanced', tooltip: 'IaC for Cloud infra' },
    { name: 'Kubernetes', icon: <SiKubernetes />, level: 'Intermediate', tooltip: 'Container orchestration' }
  ],
  DevOps: [
    { name: 'Docker', icon: <SiDocker />, level: 'Advanced', tooltip: 'Containerization' },
    { name: 'GitHub Actions', icon: <SiGithubactions />, level: 'Advanced', tooltip: 'CI/CD automation' },
    { name: 'Linux', icon: <SiLinux />, level: 'Advanced', tooltip: 'Operating system & shell' },
    { name: 'Grafana', icon: <SiGrafana />, level: 'Core', tooltip: 'Dashboards for metrics' },
    { name: 'Prometheus', icon: <SiPrometheus />, level: 'Core', tooltip: 'Monitoring/alerting' }
  ],
  Scripting: [
    { name: 'Python', icon: <SiPython />, level: 'Advanced', tooltip: 'Automation scripting' },
    { name: 'PowerShell', icon: <SiPowershell />, level: 'Intermediate', tooltip: 'Windows automation' },
    { name: 'Bash', icon: <SiGnubash />, level: 'Intermediate', tooltip: 'Linux scripting' }
  ],
  Database: [
    { name: 'PostgreSQL', icon: <SiPostgresql />, level: 'Advanced', tooltip: 'Relational DB' },
    { name: 'MySQL', icon: <SiMysql />, level: 'Advanced', tooltip: 'Open-source RDBMS' }
  ]
};

const tabs = Object.keys(skillTabs);

const Skills = () => {
  const [activeTab, setActiveTab] = useState('Cloud');

  return (
    <section id="skills" className="relative my-20 max-w-6xl mx-auto px-4 z-10">
      {/* Background SVG Overlay */}
    {/* <div
      className="absolute inset-0 z-0 opacity-5 bg-cover bg-center pointer-events-none"
      style={{ backgroundImage: "url('/circuit-pattern.svg')" }}
    /> */}

      {/* Title */}
      <motion.h2
        className="text-3xl font-bold mb-8 text-softPurple text-center relative z-10"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Skills & Toolsets
      </motion.h2>

      {/* Tab Menu */}
      <div className="flex flex-wrap justify-center gap-4 mb-8 relative z-10">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`px-5 py-2 rounded-full text-sm font-semibold border transition 
              ${
                activeTab === tab
                  ? 'bg-softPurple text-white border-softPurple'
                  : 'bg-gray-800 text-gray-400 border-gray-600 hover:border-softPurple hover:text-white'
              }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Skill Cards */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 text-white relative z-10"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.4 }}
        >
          {skillTabs[activeTab].map((skill, i) => (
            <motion.div
              key={i}
              className="bg-gray-900/70 backdrop-blur rounded-xl p-4 flex flex-col items-center justify-center shadow-lg border border-gray-700 hover:border-softPurple hover:shadow-glow transition-all cursor-pointer"
              whileHover={{ scale: 1.07, rotate: 1 }}
              transition={{ type: 'spring', stiffness: 300 }}
              title={skill.tooltip}
            >
              <div className="text-4xl text-softPurple mb-3">{skill.icon}</div>
              <p className="text-sm font-medium text-white">{skill.name}</p>
              <span className="mt-1 text-xs text-gray-400 px-2 py-0.5 bg-gray-700 rounded-full">
                {skill.level}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </section>
  );
};

export default Skills;
